/**
 * @module Helpers
 */

export default {
  /**
 * helper function
 * @function
 * @param {string} accept - string
 * @returns {string / obj } either string or obj
 */

  /**
   *
   * @param {string} - returns string first letter uppercase
   */
  firstLetterUppercase: string => string[0].toUpperCase() + string.slice(1),

  /**
   * Accept array and returns unique array
   * @param {array} - returns array
   */
  getUniqueArrayItems: arrArg => arrArg.filter((elem, pos, arr) => arr.indexOf(elem) === pos),
  
  /**
   *
   * @param {*} obj : Accept object
   * @param {*} textKey : key
   * @param {*} textValue : value
   * @param {*} inner : if inner array value
   * @returns text and key obj list from given set of args
   */
  getSelectableValue(obj, textKey, textValue, inner = false) {
    const arr = [];
    // eslint-disable-next-line
    for (const item of obj) {
      if (inner) {
        arr.push({
          text: item[inner][textKey],
          value: item[inner][textValue],
        });
      } else {
        arr.push({
          text: item[textKey],
          value: item[textValue],
        });
      }
    }
    return arr;
  },

  /**
   *
   * @param {*} data : Accept object
   * @returns : blank key value of given obj
   */
  setObjValueEmpty(data) {
    // eslint-disable-next-line
    for (const key in data) {
      data[key] = '';
    }
    return data;
  },

  /**
   *
   * @param {*} arr -- array
   * @param {*} fieldKey -- field key to return
   */
  getFieldValueInArray(arr, fieldKey) {
    if (arr.length < 1) {
      return [];
    }
    const arrData = [];
    arr.map(item => arrData.push(item[fieldKey]));
    return arrData;
  },

  /**
   *
   * @param {*} arr -- array
   * @param {*} fieldKey -- key field
   * @param {*} fieldName - fieldname to return
   */
  getInnerFieldValueInArray(arr, fieldKey, fieldName) {
    if (arr.length < 1) {
      return [];
    }
    const arrData = [];
    arr.map(item => arrData.push(item[fieldKey][fieldName]));
    return arrData;
  },

  /**
   *
   * @param {*} arr -- array
   * @param {*} searchKey -- searchKey
   * @param {*} searchvalue -- search value
   * @param {*} returnKey -- which key to return from result
   */
  filterAndGetValue(arr, searchKey, searchvalue, returnKey) {
    if (arr.length < 1) {
      return [];
    }
    const filteredData = arr.filter(item => item[searchKey] === searchvalue);
    if (filteredData) {
      return filteredData[0][returnKey];
    }
    return [];
  },

};
